document.addEventListener('DOMContentLoaded', function() {
  const ctx = document.getElementById('buildCostChart');
  if (!ctx) return;
  
  const chartDataScript = document.getElementById('buildCostChartData');
  if (!chartDataScript) return;
  
  const chartData = JSON.parse(chartDataScript.textContent);
  
  // Dynamic color assignment: known labels get fixed colors, others get fallback palette
  const normalize = (s) => (s || '').toString().trim().toLowerCase();
  // Match Liquid data-color logic: space -> '-', strip '%', collapse dashes, trim dashes
  const slugify = (s) => normalize(s)
    .replace(/\s+/g, '-')
    .replace(/%/g, '')
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  const knownColors = {
    'total accessories': '#8979FF',
    'commission 10%': '#FF928A',
    'paintjob': '#3CC3DF',
    'alignment': '#FFAE4C',
    'camber toe': '#537FF1',
    'wires': '#6FD195',
    'labor': '#8C63DA'
  };
  const fallbackPalette = ['#34A853', '#EA4335', '#FBBC05', '#1A73E8', '#9C27B0', '#00ACC1', '#F4511E', '#7CB342', '#5E35B1', '#039BE5'];
  const used = new Set(Object.values(knownColors).map(c => c.toLowerCase()));
  const assigned = [];
  const nameToColor = {};
  let fp = 0;
  chartData.labels.forEach((label) => {
    const key = normalize(label);
    let color = knownColors[key];
    if (!color) {
      // Find next unused fallback color
      let tries = 0;
      while (tries < fallbackPalette.length) {
        const c = fallbackPalette[fp % fallbackPalette.length];
        fp++;
        tries++;
        if (!used.has(c.toLowerCase())) { color = c; used.add(c.toLowerCase()); break; }
      }
      // As last resort, default purple
      if (!color) color = '#7857FF';
    }
    assigned.push(color);
    nameToColor[slugify(label)] = color;
  });
  chartData.datasets[0].backgroundColor = assigned;
  window.buildCostColorMap = nameToColor;
  
   const externalLabelsPlugin = { id: 'externalLabels', afterDraw: function() {} };
  
  const config = {
    type: 'doughnut',
    data: chartData,
    plugins: [externalLabelsPlugin],
    options: {
      responsive: true,
     maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              const label = context.label || '';
              const value = context.parsed;
              return label + ': $' + value.toLocaleString();
            }
          }
        }
      }
    }
  };
  
  const chart = new Chart(ctx, config);
  
  // Apply colors to legend dots dynamically
  const legendItems = document.querySelectorAll('.cost-legend__item');
  legendItems.forEach((item) => {
    const colorDot = item.querySelector('.cost-legend__color');
    const nameSpan = item.querySelector('.cost-legend__name');
    if (colorDot && nameSpan) {
      const labelName = nameSpan.textContent.trim();
      const slug = slugify(labelName);
      const color = nameToColor[slug];
      if (color) {
        colorDot.style.backgroundColor = color;
      }
    }
  });
  
  const reflow = () => positionLabels(chart);
  setTimeout(reflow, 100);
  window.addEventListener('resize', reflow);
});

function positionLabels(chart) {
  const chartContainer = document.querySelector('.donut-chart-container');
  const chartWithLabels = document.querySelector('.chart-with-labels');
  const labels = document.querySelectorAll('.chart-label');
  const chartElement = chart.canvas;
  
  if (!chartContainer || !chartWithLabels || !labels.length || !chartElement) return;
  
  const containerRect = chartContainer.getBoundingClientRect();
  const labelsContainerRect = chartWithLabels.getBoundingClientRect();
  const chartRect = chartElement.getBoundingClientRect();
  
  const containerWidth = containerRect.width;
  const containerHeight = containerRect.height;
  const labelsContainerWidth = labelsContainerRect.width;
  const chartSize = Math.min(chartRect.width, chartRect.height);
  const radius = chartSize / 2 * 0.6;
  
  const centerXPercent = 50;
  const centerYPercent = 50;
  
  const isMobile = containerWidth <= 750;
  const isTablet = containerWidth > 750 && containerWidth <= 1024;
  const chartRadiusPx = chartSize / 2;
  
  let rightMinGapPx, leftMinGapPx;
  if (isMobile) {
    rightMinGapPx = 55;
    leftMinGapPx = 65;
  } else if (isTablet) {
    rightMinGapPx = 40;
    leftMinGapPx = 60;
  } else {
    rightMinGapPx = 30;
    leftMinGapPx = 50;
  }
  
  const rightGapPx = chartRadiusPx + rightMinGapPx;
  const leftGapPx = chartRadiusPx + leftMinGapPx;
  const rightGapPercent = (rightGapPx / containerWidth) * 100;
  const leftGapPercent = (leftGapPx / containerWidth) * 100;
  
  const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
  let currentAngle = -Math.PI / 2;
  
  const colorMap = window.buildCostColorMap || {};
  
  const leftLabels = [];
  const rightLabels = [];
  
  labels.forEach((label, index) => {
    const dataIndex = chart.data.labels.length - 1 - index;
    const value = chart.data.datasets[0].data[dataIndex];
    const segmentAngle = (value / total) * 2 * Math.PI;
    const midAngle = currentAngle + segmentAngle / 2;
    
    const isLeftSide = midAngle > -Math.PI/2 && midAngle < Math.PI/2;
    
    label.classList.remove('label--left', 'label--right');
    label.classList.add(isLeftSide ? 'label--left' : 'label--right');
    
    if (isLeftSide) {
      leftLabels.push({ label, midAngle, value, colorClass: label.dataset.color });
    } else {
      rightLabels.push({ label, midAngle, value, colorClass: label.dataset.color });
    }
    
    currentAngle += segmentAngle;
  });
  
  const labelSpacingPercent = (60 / containerHeight) * 100;
  const totalSpacing = (Math.max(leftLabels.length, rightLabels.length) - 1) * labelSpacingPercent;
  const startOffsetPercent = -totalSpacing / 2;
  
  leftLabels.forEach((item, index) => {
    const { label, colorClass } = item;
    const labelYPercent = centerYPercent + startOffsetPercent + (index * labelSpacingPercent);
    
    label.style.position = 'absolute';
    label.style.left = `calc(${centerXPercent}% - ${leftGapPercent}%)`;
    label.style.top = `${labelYPercent}%`;
    label.style.transform = 'translate(-100%, -50%)';
    
    const amount = label.querySelector('.chart-label__amount');
    if (amount && colorMap[colorClass]) {
      amount.style.color = colorMap[colorClass];
    }
  });
  
  rightLabels.forEach((item, index) => {
    const { label, colorClass } = item;
    const labelYPercent = centerYPercent + startOffsetPercent + (index * labelSpacingPercent);
    
    const labelLeftPx = (centerXPercent / 100) * containerWidth + rightGapPx;
    const labelLeftRelativeToLabelsContainer = labelLeftPx - (labelsContainerRect.left - containerRect.left);
    const availableWidth = labelsContainerWidth - labelLeftRelativeToLabelsContainer - 20;
    const maxWidthPx = Math.max(availableWidth, 0);
    
    label.style.position = 'absolute';
    label.style.left = `calc(${centerXPercent}% + ${rightGapPercent}%)`;
    label.style.top = `${labelYPercent}%`;
    label.style.transform = 'translate(0, -50%)';
    label.style.maxWidth = `${maxWidthPx}px`;
    
    const amount = label.querySelector('.chart-label__amount');
    if (amount && colorMap[colorClass]) {
      amount.style.color = colorMap[colorClass];
    }
  });
}

